import {IPlayerMessage, IPostMessage,  PlayerMessageType, TimeChangeMsg} from "./IPlayerMessage";
import {MsgWithEvent} from "../../util/browser/PostMessageUtil";

export class PlayerMessageUtil {

    // private static ProtoHostRegex = /(\w{3,}):\/\/(.+?)(?:\/.*)?$/;
    //
    // private hasSupport(): boolean {
    //     return document.referrer !== null && document.referrer !== '';
    // }
    //
    // private static getParentOrigin(): string {
    //     const matches = this.ProtoHostRegex.exec(document.referrer);
    //     const targetOrigin = (matches !== null && matches.length == 3) ? matches[1] + '://' + matches[2] : '';
    //     return targetOrigin;
    // }

    //union types
    static createPostMessage(msg: TimeChangeMsg, messageType: PlayerMessageType): IPostMessage {
        return {msg: msg, messageType: PlayerMessageType.TimeChange}
    }

    //return union types
    static handleMessageEvent (msg: MessageEvent, playerMessage: PlayerMessageType): MsgWithEvent<TimeChangeMsg> | null {
        const playerMsg = msg.data as IPlayerMessage;
        if(playerMsg.messageType){
            switch(playerMsg.messageType){
                case PlayerMessageType.TimeChange:
                    const timeChangeMsg = playerMsg.msg as TimeChangeMsg;
                    return playerMessage == PlayerMessageType.TimeChange ? {msg: timeChangeMsg, event: msg} : null;

                default:
                    console.log(`Unsupported player message: ${playerMsg.messageType} from ${msg.origin}`);
                    return null;
            }
        } else {
            // console.log(`Message event is not a player message from ${msg.origin}:`);
            // console.log(msg.data);
            return null;
        }
    }

    // static getTimeChangeMsg(msg: MessageEvent): MsgWithEvent<TimeChangeMsg> | null {
    //     const playerMsg = this.handleMessageEvent(msg, PlayerMessageType.TimeChange);
    //     return playerMsg;
    // }

    // static registerListener(fn: (msgEvent: MessageEvent) => void){
    //     window.addEventListener("message", fn, false)
    // }
    //
    // static removeListener(fn: (evt: MessageEvent) => void){
    //     window.removeEventListener("message", fn, false)
    // }
    //
    // static sendTo(msg: IPlayerMessage, target: Window, origin: string): void {
    //         target.postMessage(msg, origin);
    // }
    //
    // static sendToParent(msg: IPlayerMessage): void {
    //     const targetOrigin = this.getParentOrigin();
    //     if (targetOrigin !== '')
    //         window.parent.postMessage(msg, targetOrigin);
    // }

}